module.exports = __webpack_public_path__ + "static/groupPic-81ee998b1b0d2de75f37bcf7014b2fdf.png";